import { Request } from 'express';
import { getAvailableLanguages, LANGUAGE_REG_EXP } from 'b2b-apps/shop/i18n/utils/language';
import { HEADERS } from 'b2b-server/core/utils/headers';
import { sanitizePath } from 'b2b-server/core/utils/path';
import { translations } from 'b2b-server/shop/assets/translations/translations';
import { LANGUAGE_CODE } from 'b2b-common/core/i18n/consts';

type TranslateFunction = (
  key: string | string[],
  params?: Record<string, string | number>,
  comment?: string,
) => string;


const detectLanguage = (request: Request, sessionLanguage: LANGUAGE_CODE = null): LANGUAGE_CODE => {
  let finalLanguage = LANGUAGE_CODE.de; // default

  const url = sanitizePath(request.path);
  const headerLanguage = request.header(HEADERS.acceptLanguage);

  // Order is important here!
  // Check session settings
  getAvailableLanguages().forEach(languageCode => {
    if (sessionLanguage === languageCode) {
      finalLanguage = languageCode;
    }
  });

  // Check request header
  getAvailableLanguages().forEach(languageCode => {
    if (headerLanguage === languageCode) {
      finalLanguage = languageCode;
    }
  });

  // Check requested URL
  getAvailableLanguages().forEach(languageCode => {
    if (LANGUAGE_REG_EXP[languageCode]?.test(url)) {
      finalLanguage = languageCode;
    }
  });

  return finalLanguage;
};

const getTranslatedText = (
  translations: Record<string, string> | undefined,
  key: string | string[],
  params?: Record<string, string | number>,
): string => {
  if (Array.isArray(key)) {
    const [pluralSingleKey, pluralMultipleKey, quantityKey] = key;

    return getTranslatedText(
      translations,
      params[quantityKey] > 1 ? pluralMultipleKey : pluralSingleKey,
      params,
    );
  }

  let text = translations?.[key] || key;

  if (params) {
    Object.entries(params).forEach(([param, value]) => {
      text = text.replaceAll(`{${param}}`, `${value}`);
    });
  }

  return text;
};

const getTranslationFromRequest = (request: Request): TranslateFunction => {
  const language = request.context.getSessionData().getSettings().language;

  return (
    key: string | string[],
    params: Record<string, string | number>,
  ): string => getTranslatedText(
    request.query.forceOutTranslations ? {} : translations[language],
    key,
    params,
  );
};

export {
  detectLanguage,
  getTranslatedText,
  getTranslationFromRequest,
};
export type { TranslateFunction };
